import React from 'react';
import { FormTitleProps } from '../../service/interfaces/Components';

const FormTitle: React.FC<FormTitleProps> = ({ title }) => {
  return (
    <div>
      <p className="font-[600] font-poppins text-[16px] leading-[42px]">{title}</p>
    </div>
  );
};

export default FormTitle;
